import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import SearchBox from '../../components/common/Search/SearchBox';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import GroupBy from '../../components/common/GroupBy/GroupBy';
import { baseurl } from '../../api';
import { isTextOnly,isRequired} from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import { useLocation, useNavigate } from "react-router-dom";
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "states"

const States = () => {
    const { setFilters, getFilters } = useFilterStore();
    const savedFilters = getFilters(pageKey);
    const [countries, setCountries] = useState([]); 
    const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
    const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
    const filterOptions = ['Default', 'Archived', 'Unarchived'];
    const groupbyOptions = ['Default', 'Country'];
    const searchCategories = ['State', 'Country'];
    const [popupError, setPopupError] = useState('');
    const [items, setItems] = useState([]);
    const location = useLocation();
    const { countryId } = location.state || {};
    const navigate = useNavigate();
    const [groupedItems, setGroupedItems] = useState({});
    const [expandedGroups, setExpandedGroups] = useState(new Set());
    const [selectedGroupByOption, setSelectedGroupByOption] = useState('Default');
    const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
    const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
    const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
    const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
    const { refreshKeys } = useRefreshStore();
    const refreshKey = refreshKeys["States"] || 0;
    

    const fetchStates = async () => {
      try {
        const params = {
          search: searchParams.term,
          search_argument: searchParams.argument,
          filter: selectedFilterOption === "Default" ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
          group_by: selectedGroupByOption.toLowerCase(),
        };
        
        if (countryId) {
          params.country = countryId;
        }
    
        const response = await authenticatedAxios.get(`${baseurl}localization/state/`, { params });
        const result = response.data;
    
        if (result.response_code === 1) {
          setItems(result.data);
          if (selectedGroupByOption !== 'Default') {
            groupItems(result.data, selectedGroupByOption);
          }
        }
      } catch (error) {
        if (error?.response?.data?.error_code === 1001) {
          navigate("/permission-denied");
        } else {
          console.error("Error fetching states:", error);
        }
        setItems([]);
      }
    };
    

  const groupItems = (data, groupBy) => {
    const grouped = data.reduce((acc, item) => {
      let key;
      switch (groupBy.toLowerCase()) {
        case 'country':
          key = item.country.name;
          break;
        default:
          key = 'default';
      }
      
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
    
    setGroupedItems(grouped);
  };

  useEffect(() => {
    fetchStates();
    fetchCountries();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedGroupByOption]);

  const fetchCountries = async () => {
    try {
        const response = await authenticatedAxios.get(`${baseurl}localization/country/`);
        const result = response.data;
        if (result.response_code === 1 && Array.isArray(result.data)) {
            setCountries(result.data.map(country => ({ label: country.name, value: country.id })));
        } else {
            console.error("Fetched countries are not valid:", result);
            setCountries([]);
        }
    } catch (error) {
        console.error("Error fetching countries:", error);
        setCountries([]);
    }
};


  useEffect(() => {
    fetchStates();
  }, [refreshKey]);

  const handleGroupBySelect = (option) => {
    setSelectedGroupByOption(option);
  };


  const toggleGroup = (groupName) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(groupName)) {
        newSet.delete(groupName);
      } else {
        newSet.add(groupName);
      }
      return newSet;
    });
  };

  const renderGroupedTable = () => {
    if (selectedGroupByOption === 'Default') {
      return (
        <tbody className='common-table-tbody'>
          {renderTableRows(items)}
        </tbody>
      );
    }
    return (
        <tbody className='common-table-tbody'>
          {Object.entries(groupedItems).map(([groupName, groupSubscriptions]) => (
            <React.Fragment key={groupName}>
              <tr className="group-header-row">
                <td colSpan="6" className="group-header">
                  <div 
                    className="group-header-content"
                    onClick={() => toggleGroup(groupName)}
                  >
                    <svg 
                      className={`expand-item-icon ${expandedGroups.has(groupName) ? 'rotated' : ''}`} 
                      width="7" 
                      height="13" 
                      viewBox="0 0 7 13" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7 6.5L0.25 12.9952L0.250001 0.00480908L7 6.5Z" fill="#424242"/>
                    </svg>
                    <span className="group-name common-text fts-15 blue">{groupName}</span>
                    <span className="group-count common-text fts-15 blue">({groupSubscriptions.length})</span>
                  </div>
                </td>
              </tr>
              {expandedGroups.has(groupName) && renderTableRows(groupSubscriptions)}
            </React.Fragment>
          ))}
        </tbody>
      );
    };
    const renderTableRows = (states) => {
        return states.length > 0 ? (
          states.map((state) => (
            <tr key={state.id} className={state.is_archived ? 'archived-item' : ''}>
              <td className="state-label">
                <input
                  className="table-selectbox table-child-selectbox"
                  type="checkbox"
                  checked={selectedItems.includes(state.id)}
                  onChange={() => handleChildCheckboxChange(state.id)}
                />
                {state.name}
              </td>
              <td>{state.state_code || 'N/A'}</td>
              <td>{state.country?.name || 'Unknown Country'}</td>
              <td className="actions common-action">
                <EditIcon
                  onClick={() =>
                    handleEditClick({
                      id: state.id,
                      name: state.name,
                      state_code: state.state_code,
                      country: state.country,
                    })
                  }
                />
                <ArchiveIcon
                  onClick={() =>
                    handleArchiveClick(state)
                  }
                  isArchived={state.is_archived}
                />
                <DeleteIcon onClick={() => handleDeleteClick(state)} />
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6">No states found.</td>
          </tr>
        );
      };
      
    const handleAddState = async (newStateData) => {
        try {
     
            const response = await authenticatedAxios.post(`${baseurl}localization/state/`, newStateData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
     
            if (response.data.response_code === 1) {
              await fetchStates();
              closePopups();
            } else {
              setPopupError(response.data.message || 'Something went wrong!');
            }
          } catch (error) {
            setPopupError('Failed to add state. Please try again.');
          }
        };
    
    const handleDelete = async () => {
      try {
        const response = await authenticatedAxios.delete(
          `${baseurl}localization/state/?id=${selectedItem.id}`
        );
    
        if (response.status >= 200 && response.status < 300) {
          setIsDeletePopupOpen(false); 
          fetchStates(); 
          return;
        }
        throw new Error(`Unexpected status code: ${response.status}`);
      } catch (error) {
        // console.error('Error deleting plan:', error);
      }
    };
    
    const handleEditState = async (editData) => {

        try {
    
            const response = await authenticatedAxios.put(
                `${baseurl}localization/state/?id=${selectedItem.id}`,
                editData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
    
            if (response.data.response_code === 1) {
              await fetchStates();
              closePopups();
            } else {
              setPopupError(response.data.message || 'Something went wrong!');
            }
          } catch (error) {
            setPopupError('Failed to add Feature. Please try again.');
          }
        };
    
    const handleArchiveSelectedItems = async () => {
        try {
          const response = await authenticatedAxios.post(`${baseurl}localization/state/archive/`, {
            id_list: selectedItems,
          });
    
          if (response.status >= 200 && response.status < 300) {
            fetchStates();
            resetCheckboxState();
            setIsArchivePopupOpen(false);
          } else {
            console.error('Failed to archive/unarchive selected items.');
          }
        } catch (error) {
          console.error('Error archiving/unarchiving selected items:', error);
        }
      };

      const handleArchive = async () => {
        try {
            await authenticatedAxios.get(
                `${baseurl}localization/state/archive/?id=${selectedItem.id}`
            );
    
            setIsArchivePopupOpen(false);
            fetchStates();
            setSelectedItem(null)
        } catch (error) {
            // Intentionally ignoring error for now
        }
    };
    
    const handleSearchSelect = (searchCategory,searchTerm) => {
        setSearchParams({
          term: searchTerm,                   
          argument: searchCategory.toLowerCase(), 
        });
    };
      
    const mapSortOptionToQuery = (option) => {
        switch (option) {
          case 'A-Z':
            return 'a_to_z';
          case 'Z-A':
            return 'z_to_a';
          case 'Newest':
            return 'newest';
          case 'Oldest':
            return 'oldest';
          default:
            return 'newest';
        }
      };

    const deletePopupFields = [
      { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
    ];

    const handleSortOptionSelect = (option) => {
        setSelectedSortOption(option); 
      };
    const handleFilterSelect = (option) => {
        setSelectedFilterOption(option); 

      };
    
    const handleEditClick = (state) => {
      setSelectedItem(state);
      setIsEditPopupOpen(true);
    };
  
  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };
   
  const handleArchiveClick = async (item) => {
      setSelectedItem(item)
      setIsArchivePopupOpen(true);
  };

  const handleNewClick = () => {
    // setSelectedItem(null);
    setIsNewPopupOpen(true);
  };

  const closePopups = () => {
      setIsEditPopupOpen(false);
      setIsArchivePopupOpen(false);
      setIsNewPopupOpen(false);
      setPopupError('');
    };

    const handleExportComplete = () => {
      resetCheckboxState();
    };
    
    return (
        <div className='whole-container'>  
            <div className='top-heading'>
                <PageHeader pageName=" Localization /" nestedpageName="States"  linkTo="" /> 
                <div className='export-container'>
                    <ArchiveSelectedItem
                    selectedItems={selectedItems}
                    items={items}
                    onArchiveSelected={handleArchiveSelectedItems}
                    />
                    <ExportLabel
                        exportUrl={`${baseurl}localization/state/export/`}
                        selectedIds={selectedItems}
                        onExportComplete={handleExportComplete}
                    />
                </div>
            </div>     
            <div className='pagename-container'>
                <div className='page-name'>
                    <h1 className='common-text fts-22 ftw-6 blue'>States</h1>
                </div>
                <div className='pagename-right-container'>
                    <AddButton onClick={handleNewClick} />
                    <SearchBox categories={searchCategories} onSearchSelect={handleSearchSelect}  defaultValue={searchParams?.term}/>
                    <GroupBy 
                        options={groupbyOptions} 
                        selectedOption={selectedGroupByOption}
                        onSelect={handleGroupBySelect}
                    />
                    <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
                    <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
                </div>
            </div>
            <div className='table-container'>
                <table className='common-table'>
                    <thead className='common-table-head'>
                        <tr className='common-table-thead-tr'>
                            <th>
                                <input
                                    className="table-selectbox table-parent-selectbox"
                                    type="checkbox"
                                    checked={isParentSelected}
                                    onChange={handleParentCheckboxChange}
                                />State Name
                            </th>
                            <th>State Code</th>
                            {/* <th>Tax Code</th> */}
                            <th>Country</th>
                            <th></th>
                        </tr>
                    </thead>
                    {renderGroupedTable()}

                </table>
            </div>

            <AddPopup 
                 isOpen={isNewPopupOpen}
                 title="Add State"
                 buttonName='Add State'
                 fields={[
                     { label: 'State Name','name':'name', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly]  },
                     { label: 'State Code','name':'state_code', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly] },
                     {
                         label: 'country','name':'country',
                         type: 'large-select',
                         options: countries,
                         defaultValue: '',
                         validators: [isRequired]
                      
                     },
                 ]}
                 onSave={handleAddState}
                 onClose={closePopups}
                 popupErrorMessage={popupError}
            />
            <EditPopup 
                isOpen={isEditPopupOpen}
                title="Edit State"
                fields={[
                    { 
                        label: 'State Name',
                        name: 'name',
                        type: 'large-input',
                        validators: [isRequired, isTextOnly],
                        defaultValue: selectedItem?.name,
                        required: true
                    },
                    { 
                        label: 'State Code',
                        name: 'state_code',
                        type: 'large-input',
                        validators: [isRequired, isTextOnly],
                        defaultValue: selectedItem?.state_code,
                        required: true
                    },
                    { 
                      label: 'Country',
                      name: 'country',
                      type: 'large-select',
                      options: countries,
                      defaultValue: selectedItem?.country?.id, // Ensure this is the country ID
                      required: true
                  }
                ]}
                onSave={handleEditState}
                onClose={closePopups}
                popupErrorMessage={popupError}
            />

            <ArchivePopup
                isOpen={isArchivePopupOpen}
                isArchived={selectedItem?.is_archived}
                // archivename={
                // selectedItem ? selectedItem.name : selectedItems.length === 1
                //     ? items.find(item => item.id === selectedItems[0])?.name || 'Unnamed Item'
                //     : `${selectedItems.length} selected item${selectedItems.length > 1 ? 's' : ''}`
                // }
                archivename={selectedItem?.name}
                onSave={handleArchive}
                onClose={() => setIsArchivePopupOpen(false)}
            />  
            <DeletePopup
              isOpen={isDeletePopupOpen}
              title="Delete States"
              fields={deletePopupFields}
              onSave={handleDelete}
              onClose={closePopups}
            />               
        </div>
    );
};

export default States;